// useSyncRootScroll.js
import { useEffect } from "react";

export default function useSyncRootScroll() {
    useEffect(() => {
        const root = document.getElementById("root");
        if (!root) return;

        const handleScroll = () => {
            const event = new Event("scroll", { bubbles: true });
            window.dispatchEvent(event); // 👈 trigger scroll listeners globally
        };

        root.addEventListener("scroll", handleScroll, { passive: true });
        return () => root.removeEventListener("scroll", handleScroll);
    }, []);
}
